import { Link } from 'react-router-dom';

import { getVerseOfDay } from '../../data/verseOfDay';

const Home = () => {
  const verseOfDay = getVerseOfDay();

  return (
    <>
      <section className="py-20 text-center hero-brand hero-brand-rocky">
        <div className="container">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="hero-kicker">Welcome to</span>
            <br />
            <span className="brand-wordmark">Ministries For Christ</span>
          </h1>
          <p className="text-xl mb-8 max-w-3xl mx-auto hero-subtext">
            Spreading the love and teachings of Jesus Christ to all nations through faith, hope, and
            love.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/about" className="btn btn-primary">
              Learn About MFC
            </Link>
            <Link to="/contact" className="btn btn-primary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container">
          <div className="card verse-of-day max-w-4xl mx-auto text-center">
            <p className="text-sm uppercase tracking-wider text-brand-muted mb-2">
              Verse of the Day
            </p>
            <p className="text-lg md:text-xl text-brand-ink mb-3">“{verseOfDay.text}”</p>
            <p className="text-brand-primary font-semibold">{verseOfDay.reference}</p>
            <p className="text-xs text-brand-muted mt-3">World English Bible (WEB)</p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Upcoming Events</h2>
            <p className="text-lg text-brand-muted max-w-2xl mx-auto">
              Join us for worship, fellowship, and spiritual growth.
            </p>
          </div>

          <div className="max-w-md mx-auto">
            <div className="card">
              <div className="text-center p-8">
                <div className="text-5xl font-bold text-brand-primary mb-4">TUE</div>
                <h3 className="text-2xl font-semibold mb-3 text-brand-primary">Bible Study</h3>
                <p className="text-brand-muted mb-5 text-lg">
                  Join us for an in-depth study of God&apos;s Word
                </p>
                <p className="text-brand-primary text-xl font-medium">6:30 PM - 8:00 PM</p>
                <p className="mt-4 text-sm text-brand-muted">Location provided upon RSVP</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-brand-soft">
        <div className="container text-center">
          <h2 className="text-3xl font-bold mb-6">Join Our Community</h2>
          <p className="text-lg text-brand-muted mb-8 max-w-3xl mx-auto">
            Whether you&apos;re new to faith or have been walking with Christ for years,
            there&apos;s a place for you here.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/about" className="btn btn-primary">
              Learn About Our Beliefs
            </Link>
            <Link to="/contact" className="btn btn-primary">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
